import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

interface FullScreenOverlayLoaderProps {
  isVisible: boolean;
  message?: string;
}

const FullScreenOverlayLoader: React.FC<FullScreenOverlayLoaderProps> = ({ isVisible, message }) => {
  if (!isVisible) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        color: "white",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <CircularProgress color="inherit" />
      {message && (
        <Typography sx={{ marginTop: 2, color: "white", fontSize: 16 }}>
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default FullScreenOverlayLoader;
